import TransferOrderController from './transferorder.controller';
import DialogController from './transferorder.edit.controller';

/**
 * this is the controller to list all transport orders
 **/
export default class TransferOrderListController extends TransferOrderController {
	/**
	 * define required services here, think of the defined services inside the constructor of the superclass
	 * @param {function} - $injector to inject all services
	 **/
	constructor($injector, $scope) {
		super($injector);
		this.$interval = $injector.get('$interval');
		this.$mdDialog = $injector.get('$mdDialog');
		this.$mdSidenav = $injector.get('$mdSidenav');
		this.$rootScope = $injector.get('$rootScope');
		this.$scope = $scope;
		this.TransferOrderService = $injector.get('TransferOrderService');
		this.DaisyValidationService = $injector.get('DaisyValidationService');
		this.TransferOrderStateService = $injector.get('TransferOrderStateService');
		this.TimeService = $injector.get('TimeService');
		this._ = $injector.get('_');
		this.moment = $injector.get('moment');
		// Custom calendar format for moment.js to remove the [at]
		this.moment.updateLocale('de', {
			calendar: {
				lastDay: '[Gestern]',
				sameDay: '[Heute]',
				nextDay: '[Morgen]',
				nextWeek: 'dddd',
				lastWeek: '[Letzten] dddd',
				sameElse: 'DD.MM.YYYY'
			}
		});
		this.LocationService = $injector.get('LocationService');
		this.UnitService = $injector.get('UnitService');
	}

	/**
	 * initialize the component and define some models
	 **/
	$onInit() {
		this.component = {
			title: 'Transportaufträge anzeigen',
			icon: ''
		};

		this.selected = [];
		this.limitOptions = [5, 10, 15];

		let currentOrder = this.TransferOrderStateService.getTableOrder();
		if (typeof currentOrder === 'undefined'){
			currentOrder = '-transportauftrNr';
		}
		this.query = {
			order: currentOrder,
			limit: 10,
			page: 1
		};

		this.filters = {
			deleted: false,
			state: {}
		};
		this.checkedFilters = [];
		this.checkedFiltersCopy = [];

		this.condition = null;
		this.conditions = null;

		this.checkDelayedOrdersInterval = this.$interval(() => {
			this.checkDelayedTransformOrders();
		}, this.checkDelayedOrderIntervalTime);

		this.searchString = '';
		this.searchFieldIsOpen = false;

		this.registerEvents();
	}

	/**
	 * change transfer order model with given order object
	 * @param {Object} order - changed order object
	 **/
	changeOrder(order) {
		const orderIndex = this._.findIndex(this.model, (obj) => {
			return obj.id == order.id;
		});
		if(orderIndex === -1){
            this.model.push(order);
		}
		else{
            this.model[orderIndex] = order;
		}

		// this.updateFilteredModel();
	}

	saveTableOrder(){
		this.TransferOrderStateService.saveTableOrder(this.query.order);
	}

	/**
	 * check all transfer orders if delayed or in time
	 **/
	checkDelayedTransformOrders() {
		this._.forEach(this.model, (obj) => {
			obj.isInTime = this.TimeService.isInTime(obj.wunschtermin, this.warningOffsetTime);
			obj.isDelayed = this.TimeService.isDelayed(obj.wunschtermin, this.dangerOffsetTime);
		});
	}

	/**
	 * delete or restore order
	 * @param  {object} order
	 * @return {void}
	 */
	deleteRestoreOrder(order) {
		this.model.forEach((item) => {
			if(item === order) {
				item.geloescht = !item.geloescht;
			}
		});
	}

	/**
	 * get condition by id
	 * @param {int} id - id for condition
	 * @return {Object} condition object with searched id
	 **/
	getConditionById(status) {
		return this._.find(this.conditions, (condition) => {
			return status === condition.status;
		});
	}

	/**
	 * check if current state is checked
	 * @param {Object} state - object with current state
	 * @return {boolean} wheter or not the current state is checked
	 **/
	isStateChecked(state) {
		return this.TransferOrderStateService.isStateChecked(state);
	}

	/**
	 * change the visibility for deleted items
	 * @return {void}
	 */
	onChangeDeletedState() {
		this.TransferOrderStateService.setDeletedItemVisibility(!this.filters.deleted);
	}

	onChangeSearchInput() {
		if(this.searchString.length) {
			this.checkedFilters = this.filters.state;
			angular.forEach(this.checkedFilters, (checkedFilter) => {
				checkedFilter.checked = true;
			});

			this.TransferOrderStateService.setCheckedFilters(this.checkedFilters);
		}
		else {
			this.resetCheckedFilters();
		}
	}


	/**
	 * change the state for the current item and save the order
	 * @param {Object} item - current transfer order
	 * @param {int} state - state number
	 **/
	onChangeState(item, state) {
		let showTransferOrder = false;

		if(state === 199){
			let isDaisyOrder = this.DaisyValidationService.getIsDaisyOrder(item);
			if (isDaisyOrder){
                showTransferOrder = true;
			}
		}

		if(showTransferOrder){
            this.showTransferOrder(null, item);
		}
		else{
            item.status = this.getConditionById(state);
            this.saveOrder(item);
		}
	}

	onClearSearchInput() {
		this.searchString = '';
		const searchInput = document.querySelectorAll('input[name="searchString"]');
		setTimeout(()=> {
			searchInput[0].focus();
		}, 100);
		this.resetCheckedFilters();
	}

	/**
	 * filter deleted items
	 * @return {function}
	 */
	filterDeletedItems() {
		if (!this.filters.deleted) {
			return (item) => {
				return !item.geloescht;
			};
		}
	}

	/**
	 * toggle search field
	 * @return {void}
	 */
	onToggleSearchField() {
		this.searchString = '';
		this.searchFieldIsOpen = !this.searchFieldIsOpen;
		const searchInput = document.querySelectorAll('input[name="searchString"]');
		setTimeout(()=> {
			if(this.searchFieldIsOpen) {
				searchInput[0].focus();
				this.checkedFiltersCopy = angular.copy(this.checkedFilters);
			}
			else {
				searchInput[0].blur();
			}
		}, 100);
		if(!this.searchFieldIsOpen) {
			this.resetCheckedFilters();
		}
	}

	registerEvents() {
		this.Socket.on('socket:transferOrder:changeOrder', (response) => {
			this.changeOrder(response.data[0]);
			this.ToastService.toast('Transportauftrag '+response.data[0].transportauftrNr+' wurde geändert.');
		});
		this.Socket.on('socket:transferOrder:newOrder', (response) => {
			if (
				response.data.length === 0 ||
				typeof response.data[0].id === 'undefined'
			){
				return;
			}
			this.model.push(response.data[0]);
			this.ToastService.toast('Neuer Transportauftrag wurde erstellt.');
		});
		this.Socket.on('socket:transferOrder:deleteOrder', (response) => {
            this.changeOrder(response.data[0]);
			this.ToastService.toast('Transportauftrag '+response.data[0].transportauftrNr+' wurde gelöscht.');
		});
	}

	/**
	 * reset checked filters to the state before user has been searched for transfer orders
	 * @return {void}
	 */
	resetCheckedFilters() {
		this.checkedFilters = angular.copy(this.checkedFiltersCopy)
		this.TransferOrderStateService.setCheckedFilters(this.checkedFilters);
	}

	/**
	 * save transfer order
	 * @param {Object} order - order to save
	 **/
	saveOrder(order) {
		// Check if transfer order is delayed or in time.
		order.isInTime = this.TimeService.isInTime(order.date, this.warningOffsetTime);
		order.isDelayed = this.TimeService.isDelayed(order.date, this.dangerOffsetTime);
		order.verantwortlichePerson = {
			id: this.$session.auth.USER_ID,
			persNr: this.$session.auth.PERS_NR,
			fullname: this.$session.auth.FULLNAME
		};
		// Create request
		let request = this.TransferOrderService.createTransferOrderEditObject(order);
		order.positionen.forEach((position, index) => {
			const pos = {
				id: position.id,
				posNr: position.posNr,
				transportgutText: position.transportgutText,
				menge: parseInt(position.menge),
				mengeneinheitId: position.mengeneinheitId
			};
			request.positionen[index] = pos;
		});

		// Send transfer oder to the backened.
		this.TransferOrderService.editTransferOrder(request)
			.then((response) => {

			})
			.catch((err) => {
				//console.log('saveForm Error', err);
				// this.ToastService.danger(err.Text);
			});
	}

	/**
	 * show transfer order in modal
	 * @param $event - current event
	 * @param {Object} item - transfer order
	 **/
	showTransferOrder($event, item) {
		this.$mdDialog.show({
			controller: DialogController,
			controllerAs: '$ctrl',
			templateUrl: 'components/transportauftrag/views/transferorder.edit.html',
			targetEvent: $event,
			resolve: {
				conditions: () => {
					return this.filters.state;
				},
				locations: () => {
					return this.LocationService.getLocations(true)
						.then((response) => {
							return response;
						})
						.catch((err) => {
							this.ToastService.danger('Fehler beim Laden der Standorte. ' + err.statusText);
						});
				},
				selectedItemTo: () => {
					return item.ziel;
				},
				transportauftrag: () => {
					item.momentDate = moment(item.wunschtermin).toDate();
					item.time = {
						hour: moment(item.wunschtermin).get('hour'),
						minute: moment(item.wunschtermin).get('minute')
					};
					item.isDaisyOrder = this.DaisyValidationService.getIsDaisyOrder(item);
					return item;
				},
				units: () => {
					return this.UnitService.getUnits(true)
						.then((response) => {
							return response;
						})
						.catch((err) => {
							this.ToastService.danger('Fehler beim Laden der Mengeneingeiten. ' + err.statusText);
						});
				}
			},
			bindToController: true,
			clickOutsideToClose: true,
		});
	}

	/**
	 * toggle Filter
	 * @param {Object} - filter object
	 **/
	toggleFilter(item) {
		item.checked = !item.checked;
	}

	/**
	 * toggle right sidebar
	 **/
	toggleSidebarRight() {
		this.$mdSidenav('right')
			.toggle()
			.then( () => {
				//console.log( this.$mdSidenav('right').isOpen() );
			});
	}

	/**
	 * update checked state filters and toggle checkbox
	 * @param {Object} item - filter object
	 **/
	updateCheckedStateFilters(item) {
		item.checked = !item.checked;
		const isEqual = this.isStateChecked(item);
		if (isEqual) {
			this._.remove(this.checkedFilters, {status: item.status});
		}
		else {
			this.checkedFilters.push(item);
		}
		this.TransferOrderStateService.setCheckedFilters(this.checkedFilters);

		// this.updateFilteredModel();
	}

	/**
	 * update the filtered model
	 **/
	updateFilteredModel() {
		this.filteredResults = this._.filter(this.model, (obj) => {
			return this._.some( this.checkedFilters, obj.state);
		});
	}

	/**
	 * the component is ready so we can update the toolbar and load the transport orders
	 **/
	$routerOnActivate(next, prev) {
		this.TransferOrderService.getTransferOrders()
			.then((response) => {
				this.model = response;
				this.checkDelayedTransformOrders();
			})
			.catch((err) => {
				this.ToastService.danger('Fehler beim Laden der Transportaufträge. ' + err.statusText);
			});

		this.TransferOrderService.ladeStatusAuswahl()
			.then((response) => {
				this.filters.state = response;
				this.filters.deleted = this.TransferOrderStateService.getDeletedItemVisibility();
				this.checkedFilters = this.TransferOrderStateService.getCheckedFilters();

				if (this.checkedFilters.length === 0) {
					this._.forEach(response, (obj) => {
						if(obj.status !== 199) {
							obj.checked = true;
							this.checkedFilters.push(obj);
						}
					});
				}

				// this.updateFilteredModel();

				this.TransferOrderStateService.setCheckedFilters(this.checkedFilters);
				this.conditions = response;
			})
			.catch((err) => {
				this.ToastService.danger('Fehler beim Laden der Status. ' + err.statusText);
			});

		this.$rootScope.$broadcast('toolbar:updateTitle', this.component);
	}

	/**
	 * remove all listeneres on destroy
	 **/
	$onDestroy() {
		this.Socket.removeAllListeners('socket:transferOrder:changeOrder');
		this.Socket.removeAllListeners('socket:transferOrder:newOrder');
		this.Socket.removeAllListeners('socket:transferOrder:deleteOrder');

		this.$interval.cancel(this.checkDelayedOrdersInterval);
	}

}
